import { forwardRef, type Ref, type SVGProps } from "react";
const IconPauseCircleFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2m-2 19a1 1 0 0 1-2 0V11a1 1 0 0 1 2 0Zm6 0a1 1 0 0 1-2 0V11a1 1 0 0 1 2 0Z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconPauseCircleFilledSVG);
ForwardRef.displayName = "IconPauseCircleFilled";
export { ForwardRef as IconPauseCircleFilled };
